import type React from "react";
import Card from "@/components/common/Card";
import FormField from "@/components/common/FormField";
import type { branch } from "@/interface/branch.interface";
import type { site } from "@/interface/site.interface";
import type { EmployeeCategory } from "@/interface/employeeOnBoard";
import { CATEGORY_OPTIONS } from "../../hooks/CreateSalaryHooks/useCreateSalary";

interface CreateSalaryFiltersBarProps {
  branches: branch[];
  selectedBranchId: string;
  isLoadingBranches: boolean;
  onBranchSelect: (branchId: string) => void;
  availableSites: site[];
  selectedSiteId: string;
  isLoadingSites: boolean;
  onSiteSelect: (siteId: string) => void;
  selectedCategory: EmployeeCategory;
  onCategoryChange: (category: EmployeeCategory) => void;
}

export const CreateSalaryFiltersBar: React.FC<CreateSalaryFiltersBarProps> = ({
  branches,
  selectedBranchId,
  isLoadingBranches,
  onBranchSelect,
  availableSites,
  selectedSiteId,
  isLoadingSites,
  onSiteSelect,
  selectedCategory,
  onCategoryChange,
}) => {
  const branchOptions = branches.map((b) => ({

    label: b.name || "Unnamed Branch",
    value: b.id || "",
  }));

  const siteOptions = availableSites.map((s) => ({
    label: s.name || "Unnamed Site",
    value: s.id || "",
  }));

  return (
    <Card className="p-4 sm:p-5 shadow-xs border border-slate-200/80 bg-white rounded-2xl">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        {/* 1. Branch Dropdown */}
        <FormField
          type="select"
          label="Select Branch"
          value={selectedBranchId}
          onChange={(e) => onBranchSelect(e.target.value)}
          options={branchOptions}
          disabled={isLoadingBranches || branchOptions.length === 0}
        />

        {/* 2. Site Dropdown */}
        <FormField
          type="select"
          label="Select Site"
          value={selectedSiteId}
          onChange={(e) => onSiteSelect(e.target.value)}
          options={siteOptions}
          disabled={!selectedBranchId || isLoadingSites || siteOptions.length === 0}
        />

        {/* 3. Category Dropdown */}
        <FormField
          type="select"
          label="Employee Category"
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value as EmployeeCategory)}
          options={CATEGORY_OPTIONS}
        />
      </div>
    </Card>
  );
};
